export default __webpack_public_path__ + "static/media/logoFundoClaro.db5b2f51.svg";